import api from "../api/axios";

async function getNotificationAll() {
  const response = await api.get("/notifications");
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

async function markNotification(notification_id) {
  const response = await api.put("/notifications/" + notification_id, {});
  if (!response) {
    throw new Error(response.statusText);
  }

  return response;
}

export { getNotificationAll, markNotification };
